import React from "react";
import styled from "styled-components";
import CountUp from "react-countup";
import { motion } from "framer-motion";
import { Link as ScrollLink } from "react-scroll";

const Specialties = () => {
  return (
    <Wrapper>
      <Intro as={motion.div}
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      ><Heading>LK EDUCATION HUB</Heading>

        <SubHeading>Empowering Careers Through Practical Training</SubHeading>

        <Description>
          At LK Education, we focus on delivering industry-ready training in
          Accounting, TallyPrime, GST, MS Office, and Business Skills.
          Our mission is to help students and professionals build strong
          foundational skills and secure better career opportunities with
          practical, job-oriented learning.
        </Description>

      </Intro>

      <StatsGrid>
        {stats.map((stat, index) => (
          <StatCard
            as={motion.div}
            key={index}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: index * 0.1 }}
          >
            <StatNumber>
              <CountUp end={stat.number} duration={2} enableScrollSpy />
              +
            </StatNumber>
            <StatLabel>{stat.label}</StatLabel>
          </StatCard>
        ))}
      </StatsGrid>

      <CTA as={motion.div}
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: 0.4 }}
      >
        <ScrollLinkStyled to="contact" smooth={true} duration={500}>
          CONNECT WITH US
        </ScrollLinkStyled>
      </CTA>
    </Wrapper>
  );
};

export default Specialties;

const stats = [
  { number: 2500, label: "Students Successfully Trained" },
  { number: 12, label: "Years of Training Excellence" },
  { number: 15, label: "Professional Courses Offered" },
  { number: 300, label: "Partnered Companies & Employers" },
];


const Wrapper = styled.section`
  padding: 20px 20px 80px 20px;
  background: ${(props) => props.theme.colors.extralight};
  color: ${(props) => props.theme.colors.dark};
  text-align: center;
`;

const Intro = styled.div`
  max-width: 800px;
  margin: 0 auto 60px auto;
`;
const ScrollLinkStyled = styled(ScrollLink)`
  background: ${(props) => props.theme.colors.secondary};
  color: #fff;
  padding: 14px 28px;
  font-size: 1rem;
  border-radius: 8px;
  text-decoration: none;
  cursor: pointer;
  display: inline-block;
  transition: background 0.3s ease;

  &:hover {
    background: #1e7a79;
  }
`;

const Heading = styled.h2`
  font-size: 2.5rem;
  font-weight: bold;
  color: ${(props) => props.theme.colors.secondary};

  @media (max-width: 500px) {
    font-size: 2rem;
  }
`;

const SubHeading = styled.h3`
  font-size: 1.5rem;
  margin-top: 10px;
  color: ${(props) => props.theme.colors.dark};

  @media (max-width: 500px) {
    font-size: 1.2rem;
  }
`;

const Description = styled.p`
  font-size: 1.1rem;
  margin-top: 20px;
  color: #333;

  @media (max-width: 500px) {
    font-size: 1rem;
  }
`;

const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 30px;
  margin-top: 40px;
`;

const StatCard = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 30px 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-5px);
  }
`;

const StatNumber = styled.h4`
  font-size: 2.2rem;
  color: ${(props) => props.theme.colors.secondary};
  margin-bottom: 10px;
`;

const StatLabel = styled.p`
  font-size: 1rem;
  color: #555;
`;

const CTA = styled.div`
  margin-top: 50px;
`;

const CTAButton = styled.a`
  background: ${(props) => props.theme.colors.secondary};
  color: #fff;
  padding: 14px 28px;
  font-size: 1rem;
  border-radius: 8px;
  text-decoration: none;
  transition: background 0.3s ease;

  &:hover {
    background: #1e7a79;
  }
`;
